import type { TourDefinition } from "@/types/tour";

export const projectLeadsTour: TourDefinition = {
  id: "project-leads",
  context: "terminus-admin",
  version: 1,
  path: "/project-leads",
  steps: [
    {
      element: '[data-tour-id="shaping-inbox"]',
      popover: {
        title: "Unassigned opportunities",
        description:
          "Every approved opportunity not yet in a lead waits here. Select several to merge them, or move one into a lead.",
      },
    },
    {
      element: '[data-tour-id="shaping-lead-column"]',
      popover: {
        title: "Project lead container",
        description:
          "Each column is a project lead with its grouped opportunities. Generate a one-pager or finalize it into a Project from the column header.",
      },
    },
  ],
};
